import React, { useEffect } from 'react'
import { Switch, withRouter } from 'react-router-dom'
import './Course.sass'
import withStore from '../../Components/Unstated/withStore'
import CourseStore from './Store/CourseStore'
import Loading from '../../Components/Loading/Loading'
import Route from '../../Components/Router/Route'
import Dashboard from './Components/Dashboard/Dashboard'
import Reviews from './Components/Reviews/Reviews'
import UserStore from '../UserAuth/Store/UserStore'
import LeaveReview from './Components/LeaveReview'
import GroupCourseDashboard from './Components/Dashboard/Components/GroupCourseDashboard'

const Course = ({
  userStore: { state: user },
  courseStore: {
    init,
    state: { loading },
  },
  match: {
    params: { livDemyID, courseURL },
    path,
  },
  history,
}) => {
  useEffect(() => {
    ;(async () => {
      const isValidCourse = await init({
        livDemyID,
        courseURL,
        user,
      })

      if (!isValidCourse) {
        history.push(`/${livDemyID}`)
      }

      window.scroll({ top: 0, left: 0, behavior: 'smooth' })
    })()
  }, [courseURL, history, init, livDemyID, user])

  useEffect(() => {
    const element = document.getElementsByClassName('courseDashboard')[0]
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      })
    }
  }, [])

  return loading ? (
    <Loading full />
  ) : (
    <div className='course'>
      <Switch>
        <Route path={`${path}/reviews`} render={() => <Reviews />} />
        <Route
          path={`${path}/leave-a-review`}
          render={() => (
            <LeaveReview courseURL={courseURL} livDemyID={livDemyID} />
          )}
          isPrivate
        />
        <Route
          path={`${path}/dashboard/:batchId`}
          render={() => <GroupCourseDashboard />}
          isPrivate
        />
        <Route
          path={`${path}/dashboard`}
          render={() => <GroupCourseDashboard />}
          isPrivate
        />
        <Route path={path} render={() => <Dashboard />} />
      </Switch>
    </div>
  )
}

export default withStore([UserStore, CourseStore])(withRouter(Course))
